import { styled } from "@mui/material/styles";
import Box from "@mui/material/Box";
import MaterialCard from "@mui/material/Card";
import { ReactComponent as AwardIcon } from "./icons/Award.svg";
import { ReactComponent as TimeIcon } from "./icons/Time.svg";
import { ReactComponent as LampIcon } from "./icons/Lamp.svg";
import { ReactComponent as TagIcon } from "./icons/Tag.svg";
import { getInvertColor, isLightColor } from "utils/themeUtils";
import { Typography } from "@mui/material";

export const Container = styled(Box)(({ theme }) => ({
	backgroundColor: theme.palette.primary.main,
	width: "100%",
	height: "100vh",
	position: "relative",
	[theme.breakpoints.down("mobile")]: {
		height: "fit-content",
	},
}));

export const Line = styled("div")(({ theme }) => ({
	position: "absolute",
	top: "8%",
	left: "45px",
	border: "2px solid",
	borderColor: theme.palette.common.white,
	zIndex: 0,
	height: `calc(100% + 20px - 6%)`,
	width: "1px",
	[theme.breakpoints.down("md")]: {
		display: "none",
	},
}));

export const Circle1 = styled("div")(({ theme }) => ({
	position: "absolute",
	left: "-0.75rem",
	zIndex: 0,
	backgroundColor: theme.palette.common.white,
	borderRadius: "50%",
	width: "1.5rem",
	height: "1.5rem",
	top: "-0.75rem",
	[theme.breakpoints.down("md")]: {
		display: "none",
	},
}));

export const Circle2 = styled("div")(({ theme }) => ({
	position: "absolute",
	left: "-0.5rem",
	zIndex: 0,
	width: "1.25rem",
	borderRadius: "50%",
	backgroundColor: theme.palette.common.white,
	height: "1.25rem",
	bottom: "-0.5rem",
	[theme.breakpoints.down("md")]: {
		display: "none",
	},
}));

export const Title = styled(Box)(({ theme }) => ({
	color: getInvertColor(theme.palette.primary.main),
	display: "flex",
	height: "100px",
	alignSelf: "",
	textAlign: "center",
	justifyContent: "center",
	alignItems: "center",
	fontSize: "2.5rem",
	fontWeight: 900,
	position: "relative",
	[theme.breakpoints.down("md")]: {
		display: "none",
	},
}));

export const CardContainer = styled("div")(({ theme }) => ({
	top: "4%",
	display: "flex",
	position: "relative",
	gap: "2em",
	padding: "0.5em 1.25rem",
	flexWrap: "wrap",
	flexDirection: "column",
	[theme.breakpoints.down("md")]: {
		height: "100%",
		top: "0px",
		padding: "1rem",
		display: "flex",
		flexDirection: "row",
		flexWrap: "wrap",
		maxWidth: "100vw",
		overflowX: "auto",
		gap: "1em",
	},
	[theme.breakpoints.down("mobile")]: {
		display: "grid",
		gridTemplateColumns: "1fr 1fr",
		gridTemplateRows: "1fr 1fr",
		height: "fit-content",
	},
}));

export const Card = styled(MaterialCard)(({ theme }) => ({
	zIndex: 1,
	width: "100%",
	padding: "1rem 0.75rem",
	display: "flex",
	justifyContent: "space-between",
	alignItems: "center",
	[theme.breakpoints.down("md")]: {
		padding: "0.5rem",
		zIndex: 0,
	},
	[theme.breakpoints.down("mobile")]: {
		height: "fit-content",
		padding: 8,
	},
	[theme.breakpoints.up("xl")]: {
		padding: "1.25rem",
		zIndex: 0,
	},
}));
export const InfoContainer = styled(Box)(({ theme }) => ({
	display: "flex",
	paddingLeft: "10px",
	flexDirection: "column",
	justifyContent: "center",
	alignItems: "stretch",
	[theme.breakpoints.down("md")]: {
		padding: "0.5rem",
		width: "180px",
		zIndex: 0,
	},
	[theme.breakpoints.down("mobile")]: {
		flexDirection: "row",
		justifyContent: "flex-start",
		columnGap: 5,
		alignItems: "center",
	},
}));
export const Content = styled(Box)(({ theme }) => ({
	fontVariantNumeric: "ordinal",
	color: isLightColor(theme.palette.secondary.main)
		? isLightColor(theme.palette.primary.main)
			? "#000"
			: theme.palette.primary.main
		: theme.palette.secondary.main,
	fontSize: "3rem",
	fontWeight: "bold",
	[theme.breakpoints.up("lg")]: {
		fontSize: "2rem",
	},
	[theme.breakpoints.up("xl")]: {
		fontSize: "3rem",
	},
	[theme.breakpoints.down("md")]: {
		fontSize: "1.25rem",
	},
	[theme.breakpoints.down("mobile")]: {
		fontSize: 16,
		color: "black",
	},
}));
export const Annotation = styled(Box)(({ theme }) => ({
	textTransform: "uppercase",
	fontSize: "1rem",
	[theme.breakpoints.down("md")]: {
		fontSize: "0.75rem",
	},
	[theme.breakpoints.down("mobile")]: {
		textTransform: "none",
		alignSelf: "flex-end",
		fontWeight: "bold",
	},
}));
export const IconContainer = styled(Box)(({ theme }) => ({
	padding: "1rem",
	height: "80px",
	width: "80px",
	backgroundColor: theme.palette.primary.light,
	borderRadius: "50%",
	display: "flex",
	justifyContent: "center",
	alignItems: "center",

	[theme.breakpoints.down("md")]: {
		height: "60px",
		width: "60px",
	},
}));

export const AwardIconWrapper = styled(AwardIcon)(({ theme }) => ({
	"& .award": {
		fill: theme.palette.secondary.main,
	},
}));

export const TimeIconWrapper = styled(TimeIcon)(({ theme }) => ({
	"& .timer": {
		fill: theme.palette.secondary.main,
	},
}));

export const LampIconWrapper = styled(LampIcon)(({ theme }) => ({
	"& .lamp": {
		fill: theme.palette.secondary.main,
	},
}));
export const TagIconWrapper = styled(TagIcon)(({ theme }) => ({
	"& .tag": {
		fill: theme.palette.secondary.main,
	},
}));

export const Finish = styled(Typography)(({ theme }) => ({
	[theme.breakpoints.down("mobile")]: {
		width: "100%",
		display: "flex",
		justifyContent: "center",
		fontWeight: "bold",
		fontSize: "1rem",
		color: getInvertColor(theme.palette.primary.main),
		paddingTop: 18,
	},
}));
